import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Sidebar from "../componenteExtra/SidebarsocioGET";
import Modal from "../componenteExtra/modal";
import "../App.css";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

const SolicitudesAnuladas = () => {
  const [assignments, setAssignments] = useState([]);
  const [filteredAssignments, setFilteredAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [razonSocialFilter, setRazonSocialFilter] = useState("");

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    fetchCancelledAssignments();
  }, []);

  useEffect(() => {
    filterAssignments();
  }, [startDate, endDate, razonSocialFilter, assignments]);

  const fetchCancelledAssignments = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_cancelled_assignments`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAssignments(response.data);
        setFilteredAssignments(response.data);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  };

  const filterAssignments = () => {
    const filtered = assignments.filter((assignment) => {
      const assignmentDate = new Date(assignment.fecha_de_termino);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      const razonSocialMatch = razonSocialFilter
        ? assignment.razon_social.toLowerCase().includes(razonSocialFilter.toLowerCase())
        : true;

      return (
        razonSocialMatch &&
        (!start || assignmentDate >= start) &&
        (!end || assignmentDate <= end)
      );
    });
    setFilteredAssignments(filtered);
  };

  const openModal = (assignment) => {
    setSelectedAssignment(assignment);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedAssignment(null);
  };

  const handleDownload = () => {
    // Filtrar assignments ya está filtrado por fecha y razón social
    const filteredAssignmentsForExcel = filteredAssignments;

    // Convertir los datos a un sheet de Excel
    const sheet = XLSX.utils.json_to_sheet(filteredAssignmentsForExcel);

    // Crear el workbook de Excel
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Solicitudes Anuladas");

    // Generar el archivo de Excel
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "solicitudes_anuladas.xlsx");
  };

  // Definir el contador de actividades filtradas
  const totalActividades = filteredAssignments.length;

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Solicitudes anuladas</h1>
          {/* Mostrar el contador de actividades */}
          <h2>Total Actividades: {totalActividades}</h2>
          {/* Contenedor de filtros */}
          <div className="filter-container">
            {/* Filtro por Razón Social */}
            <label>
              Filtrar por Razón Social:
              <input
                type="text"
                value={razonSocialFilter}
                onChange={(e) => setRazonSocialFilter(e.target.value)}
                placeholder="Ingrese razón social"
              />
            </label>
          </div>
          <button onClick={handleDownload} className="download-button">
            Descargar planilla
          </button>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Código Proyecto</th>
                  <th>Nombre Proyecto</th>
                  <th>Razón Social</th>
                  <th>Filial</th>
                  <th>Solicitante</th>
                  <th>Tipo de trabajo</th>
                  <th>Regulación</th>
                  <th>Rubro GET</th>
                  <th>Nombre Actividad GET</th>
                  <th>Staff Asignado</th>
                  <th>Correo Staff</th>
                  <th>Fecha de Inicio</th>
                  <th>Fecha de Término</th>
                  <th>Motivo Cancelación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredAssignments.length > 0 ? (
                  filteredAssignments.map((assignment, index) => (
                    <tr key={index}>
                      <td>{assignment.codigo_proyecto}</td>
                      <td>{assignment.nombre_proyecto}</td>
                      <td>{assignment.razon_social}</td>
                      <td>{assignment.filial}</td>
                      <td>{assignment.nombre_solicitante}</td>
                      <td>{assignment.tipo_solicitud}</td>
                      <td>{assignment.tipo_regulacion}</td>
                      <td>{assignment.rubro_get}</td>
                      <td>{assignment.nombre_actividad_get}</td>
                      <td>{assignment.staff_asignado}</td>
                      <td>{assignment.correo}</td>
                      <td>{assignment.fecha_de_inicio}</td>
                      <td>{assignment.fecha_de_termino}</td>
                      <td>{assignment.motivo_cancelacion}</td>
                      <td>
                        <button
                          onClick={() => openModal(assignment)}
                          className="purple-button"
                        >
                          Ver Detalles
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14">No se encontraron actividades.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {selectedAssignment && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          title="Detalles de la Cancelación"
        >
          <div className="modal-details">
            <p>
              <strong>Código Proyecto:</strong> {selectedAssignment.codigo_proyecto}
            </p>
            <p>
              <strong>Estado Asignaciones:</strong> {selectedAssignment.estado_asignaciones}
            </p>
            <p>
              <strong>Nombre Proyecto:</strong> {selectedAssignment.nombre_proyecto}
            </p>
            <p>
              <strong>Razón Social:</strong> {selectedAssignment.razon_social}
            </p>
            <p>
              <strong>Filial:</strong> {selectedAssignment.filial}
            </p>
            <p>
              <strong>Socio de auditoría:</strong> {selectedAssignment.encargado_auditoria}
            </p>
            <p>
              <strong>Rubro GET:</strong> {selectedAssignment.rubro_get}
            </p>
            <p>
              <strong>Nombre Actividad GET:</strong> {selectedAssignment.nombre_actividad_get}
            </p>
            <p>
              <strong>Número Grupo:</strong> {selectedAssignment.numero_grupo}
            </p>
            <p>
              <strong>Jefe de Grupo:</strong> {selectedAssignment.jefe_grupo}
            </p>
            <p>
              <strong>Subrogante:</strong> {selectedAssignment.subrogante}
            </p>
            <p>
              <strong>Fecha de Entrega de Información:</strong> {selectedAssignment.fecha_entrega_informacion}
            </p>
            <p>
              <strong>Enlace Comentario:</strong>{" "}
              <a href={selectedAssignment.enlace_comentario} target="_blank" rel="noopener noreferrer">
                {selectedAssignment.enlace_comentario}
              </a>
            </p>
            <p>
              <strong>Staff Asignado:</strong> {selectedAssignment.staff_asignado}
            </p>
            <p>
              <strong>Correo Staff:</strong> {selectedAssignment.correo}
            </p>
            <p>
              <strong>Fecha de Inicio:</strong> {selectedAssignment.fecha_de_inicio}
            </p>
            <p>
              <strong>Fecha de Término:</strong> {selectedAssignment.fecha_de_termino}
            </p>
            <p>
              <strong>Horas GET:</strong> {selectedAssignment.horas_get}
            </p>
            <p>
              <strong>Horas Estándar:</strong> {selectedAssignment.horas_estandar}
            </p>
            <p>
              <strong>Motivo Cancelación:</strong> {selectedAssignment.motivo_cancelacion}
            </p>
          </div>
        </Modal>
      )}
      <Toaster />
    </div>
  );
};

export default SolicitudesAnuladas;
